"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WirelessProductRexRespnseMapper = void 0;
var WirelessProductRexRespnseMapper = /** @class */ (function () {
    function WirelessProductRexRespnseMapper(data) {
        this.localData = data;
    }
    WirelessProductRexRespnseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return WirelessProductRexRespnseMapper;
}());
exports.WirelessProductRexRespnseMapper = WirelessProductRexRespnseMapper;
//# sourceMappingURL=WirelessProductRexRespnseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/WirelessProductRexRespnseMapper.js
// module id = 1448
// module chunks = 8